var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextjs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1124 1.66444C10.1747 -3.00285 0.0883374 2.69765 0.000575016 11.9007C-0.0851251 20.8874 9.42538 26.6919 17.3453 22.7365L8.69814 10.0142L8.69814 17.8891C8.69814 18.7616 7.0285 18.7616 7.0285 17.8891V7.33222C7.0285 6.63961 8.31509 6.58277 8.67968 7.18483L18.5358 22.0581C25.9397 17.2891 25.8397 6.20796 18.1124 1.66444ZM16.9989 16.5678L15.324 14.0095V7.00586C15.324 6.35277 16.9989 6.35277 16.9989 7.00586V16.5678Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextjs);
export default __webpack_public_path__ + "static/media/nextjs.225193fe0ac340b908745919844c3766.svg";
export { ForwardRef as ReactComponent };